import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';
import stages from '../stages';

/**
 * Direct traffic towards either express or loopback for migration endpoints.
 * When ON, uses Express host/builder. When OFF, falls back to LoopBack host/builder.
 *
 * This is a long-lived migration split covering all waves/batches of the
 * LoopBack-to-Express migration (comments, multisite, shared files, monthly
 * quota totals, etc.). Regions are added to ENABLED_REGIONS incrementally as
 * each wave completes dev validation.
 *
 * All stages (local, dev, staging, demo, production) share the same
 * evaluationFn so that a region is enabled or disabled uniformly across
 * environments — there is no gradual per-stage rollout within this split.
 *
 * Allowlist pattern: all regions OFF by default. Add regions to ENABLED_REGIONS
 * to turn on Express migration for that region.
 *
 * When region is unknown (e.g. new browser tab with empty sessionStorage,
 * or cold start before region-config fetch completes), defaults to ON
 * because LoopBack is being deprecated and is turned off in some
 * environments. This is consistent with the other use_express_* splits
 * (dropoff, lab, pickup, route_session) which also default to ON.
 */
const ROLLOUT_WAVE_2_REGIONS = [Region.UDA, Region.MMPA, Region.UNC, Region.LEGACY, Region.PSC, Region.IMP, Region.MINERVA, Region.BONGARDS];

const ENABLED_REGIONS = [Region.CDI, ...Object.values(Region.TCJ), Region.UDI, ...ROLLOUT_WAVE_2_REGIONS];

const prod = new Environment({
    name: stages.PRODUCTION,
    evaluationFn: (attributes) => {
        if (!attributes?.region) return 'on';
        if (ENABLED_REGIONS.includes(attributes.region)) return 'on';
        return 'off';
    },
});

const local = new Environment({
    ...prod,
    name: stages.LOCAL,
});

const dev = new Environment({
    ...prod,
    name: stages.DEV,
});

const staging = new Environment({
    ...prod,
    name: stages.STAGING,
});

const demo = new Environment({
    ...prod,
    name: stages.DEMO,
});

const use_express_migration_endpoints = new MockSplit({
    name: 'use_express_migration_endpoints',
    environments: [local, dev, staging, demo, prod],
});

export default use_express_migration_endpoints;
